//
//
//
//
//
//
//
//
//

export default {
  name: 'video-player-gallery-item',
  props: {
    // previews: Object,
    element: Object,
  },
  data() {
    return {
      player: {},
    };
  },
  computed: {
    // videoSources() {
    //   const sources = [];

    //   if (this.previews.mp4) {
    //     sources.push({
    //       type: 'video/mp4',
    //       src: this.previews.mp4.url,
    //     });
    //   }
    //   return sources;
    // },
    posterImg() {
      if (this.element.previews.jpg) {
        return `background-image:url(${this.element.previews.jpg.url})`;
      }
      return '';
    },
  },
  mounted() {
    this.initVideoPlayer();
    // eslint-disable-next-line
    // this.player = flowplayer(this.$refs.videoPlayer, {
    //   splash: true,
    //   loop: true,
    //   key: '$997983260150586',
    //   clip: {
    //     sources: this.videoSources,
    //   },
    // });
  },
  updated() {
    this.unloadVideoPlayer();
    this.initVideoPlayer();
    // this.player.unload();
    // this.player = flowplayer(this.$refs.videoPlayer, {
    //   splash: true,
    //   loop: true,
    //   key: '$997983260150586',
    //   clip: {
    //     sources: this.videoSources,
    //   },
    // });
  },
  methods: {
    unloadVideoPlayer() {
      this.$videoPlayer.unload();
    },
    // shutdownVideoPlayer() {
    //   this.$videoPlayer.shutdown();
    // },
    initVideoPlayer() {
      // init video player
      this.$videoPlayer.init(this.$refs.videoPlayer, this.element);
    },
  },
};
